import type { ReactNode } from 'react';

import styles from '@/components/book/Kicker.module.css';
import { Link } from '@/lib/navigation';

interface KickerProps {
  shelf?: { name: string; href: string };
  /** Set in italic after the shelf, e.g. `Revised yesterday`. */
  children?: ReactNode;
  className?: string;
}

/** The small line over a story: shelf, then why it is here. */
export function Kicker({ shelf, children, className }: KickerProps) {
  return (
    <p className={[styles.kicker, className].filter(Boolean).join(' ')}>
      {shelf && <Link to={shelf.href} className={styles.shelf}>{shelf.name}</Link>}
      {shelf && children != null && ' '}
      {children != null && <span className={styles.reason}>{children}</span>}
    </p>
  );
}
